(function () {
  angular
    .module('kareo.errors', [
      'kareo.errors.recent-http-history-service',
      'kareo.errors.recent-route-history-service'
    ])
    .provider('KareoErrors', KareoErrorsProvider)
    .factory('$exceptionHandler', kareoExceptionHandler);

  function KareoErrorsProvider() {
    this.getLogger = function ($log) {
      return {
        error(...args) {
          $log.error(...args);
          if (window.Rollbar) {
            window.Rollbar.error(...args);
          }
        },
        warn(...args) {
          $log.warn(...args);
          if (window.Rollbar) {
            window.Rollbar.warning(...args);
          }
        },
        debug(...args) {
          $log.debug(...args);
          if (window.Rollbar) {
            window.Rollbar.debug(...args);
          }
        }
      };
    };
    this.$get = [
      '$log', function ($log) {
        return this.getLogger($log);
      }
    ];
  }

  kareoExceptionHandler.$inject = ['$injector'];
  function kareoExceptionHandler($injector) {
    return function (exception, cause) {
      var extras, KareoErrors;
      // this is hacky, but avoids circular dependency
      KareoErrors = $injector.get('KareoErrors');

      extras = {
        cause
      };

      // note - http / route history removed 3/20/2017

      if (exception instanceof Error && exception.context) {
        extras.context = exception.context;
      }

      KareoErrors.error(exception, extras);
    };
  }
})();
